import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "rightButton"]
  static values = { exploreUrl: String }

  connect() {
    this.updateEndState()
  }

  scrollLeft() {
    this.scrollByAmount(-this.scrollStep())
    this.updateEndState()
  }

  scrollRight() {
    if (this.atEnd()) {
      window.location.href = this.exploreUrlValue
      return
    }
    this.scrollByAmount(this.scrollStep())
    this.updateEndState()
  }

  scrollByAmount(amount) {
    if (!this.hasContainerTarget) return
    this.containerTarget.scrollBy({ left: amount, behavior: "smooth" })
  }

  scrollStep() {
    if (!this.hasContainerTarget) return 0
    return Math.max(200, Math.floor(this.containerTarget.clientWidth * 0.8))
  }

  atEnd() {
    if (!this.hasContainerTarget) return false
    const container = this.containerTarget
    return container.scrollLeft + container.clientWidth >= container.scrollWidth - 2
  }

  updateEndState() {
    if (!this.hasRightButtonTarget) return
    this.rightButtonTarget.classList.toggle("bg-ink/10", this.atEnd())
    this.rightButtonTarget.classList.toggle("text-ink", this.atEnd())
  }

  onScroll() {
    this.updateEndState()
  }
}
